var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_328_6626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_328_6626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7891 -1.4707L16.5692 -1.4707C7.41827 -1.4707 0 5.94758 0 15.0985V16.0006C0 24.8371 7.16344 32.0006 16 32.0006C24.8366 32.0006 32 24.8371 32 16.0006V4.74022C32 1.31002 29.2193 -1.4707 25.7891 -1.4707Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1234 12.4569L15.961 9.1487L21.2595 12.4569V20.4912H18.7254L18.4951 22.8543H13.8877V20.4912H11.1234V12.4569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7781 20.1473H19.0282V13.6577L16.2307 11.9619L13.4326 13.6577V20.1473H11.5897V12.7637L16.1839 9.66999L20.7781 12.7637V20.1473ZM17.9451 22.3253H14.5152V14.3832L16.2307 13.3439L17.9451 14.3832V22.3253ZM16.1839 8.46094L10.667 12.1765V21.1841H13.4326V23.5414H19.0282V21.1841H21.7015V12.1765L16.1839 8.46094Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ddf227e27838dae4caffb5bf57c40e52.svg";
export { ForwardRef as ReactComponent };